import { render, staticRenderFns } from "./TenantStatus.vue?vue&type=template&id=446df40c"
import script from "./TenantStatus.vue?vue&type=script&lang=js"
export * from "./TenantStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports